import { MODE } from '~/shared/components/DarkMode/constants.ts'
import { ACTION } from '~/shared/services/actions.ts'

export interface SetPreferColorSchemeCookieProps {
  mode: MODE,
  preferredColorScheme: MODE.LIGHT | MODE.DARK,
  submitFunction?: (data: any, options: any) => void
}

// Function mocked in test/setup-test-env.tsx
export const setPreferColorSchemeCookie = async ({ mode, preferredColorScheme, submitFunction }: SetPreferColorSchemeCookieProps) => {
  submitFunction?.({ mode, preferredColorScheme }, { method: 'POST', action: ACTION.SET_MODE(), })
}